import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'

import Link from './Link'
import * as UnitActionCreators from '../../actions/unit'
import * as CommunityActionCreators from '../../actions/community'

class CommunityUnitNameContainer extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    unitId: PropTypes.number.isRequired,
    units: PropTypes.object.isRequired,
    unitActions: PropTypes.object.isRequired,
    communities: PropTypes.object.isRequired,
    communityActions: PropTypes.object.isRequired,
    delimiter: PropTypes.string,
    linkable: PropTypes.bool,
  }

  static defaultProps = {
    delimiter: '-',
    linkable: false,
  }

  static styles = () => ({
    root: {
      textDecoration: 'none',
    },
  })

  static mapStateToProps(state) {
    return {
      communities: state.communities,
      units: state.units,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      unitActions: bindActionCreators(UnitActionCreators, dispatch),
      communityActions: bindActionCreators(CommunityActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.update()
  }

  componentDidUpdate() {
    this.update()
  }

  update() {
    const {
      unitId,
      unitActions, communityActions,
    } = this.props
    unitActions.fetchUnit(unitId)
    const communityId = this.communityId()
    if (communityId) {
      communityActions.fetchCommunity(communityId)
    }
  }

  unitId() {
    return this.props.unitId
  }

  unit() {
    const { units } = this.props
    return units[this.unitId()]
  }

  unitName() {
    return (this.unit() || { name: this.unitId() }).name
  }

  communityId() {
    return (this.unit() || {}).community_id
  }

  community() {
    const { communities } = this.props
    return communities[this.communityId()]
  }

  communityName() {
    return (this.community() || { name: this.communityId() }).name
  }

  render() {
    const { classes, delimiter, linkable } = this.props
    if (linkable) {
      return (
        <span>
          <Link className={classes.root} to="/">Dashboard</Link>
          {` ${delimiter} `}
          <Link className={classes.root} to={`/communities/${this.communityId()}`}>{this.communityName()}</Link>
          {` ${delimiter} `}
          <Link className={classes.root} to={`/units/${this.unitId()}`}>{this.unitName()}</Link>
        </span>
      )
    }

    return (`${this.communityName()} ${delimiter} ${this.unitName()}`)
  }
}

export default connect(
  CommunityUnitNameContainer.mapStateToProps,
  CommunityUnitNameContainer.mapDispatchToProps,
)(withStyles(CommunityUnitNameContainer.styles)(CommunityUnitNameContainer))
